import React from 'react';
import Container from 'components/Container';
import Image from 'components/Image';
import Link from 'components/Link';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
import CoachingHeading from 'coaching/components/CoachingHeading';

import 'coaching/components/styles/CoachingHelpHomeIntro.scss';

export default function CoachingHelpHomeIntro({
  isAuthenticated,
  firstName,
}: {
  isAuthenticated: boolean;
  firstName?: string | null;
}) {
  return (
    <Container>
      <MediaObject figure="right" className="CoachingHelpHomeIntro-wrapper" center>
        <div>
          <CoachingHeading size="xsmall" textSize="xxxxlarge">
            How can we help?
          </CoachingHeading>
          <Text size="medium" color="graphite">
            Our Tutoring team is here for you{firstName ? `, ${firstName}. ` : '. '}
            {!isAuthenticated && (
              <Link to="/log_in" color="koolaid" weight="semibold">
                Log in to resolve your issue quicker.
              </Link>
            )}
          </Text>
        </div>
        <Image
          src={require('assets/images/coaching/bike_doodle.png')}
          className="CoachingHelpHomeIntro-illustration"
        />
      </MediaObject>
    </Container>
  );
}
